import React from "react";
import { Typography, Grid, Card, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import GoBackButton from "components/GoBackButton";
import Userinfo from "../components/Userinfo";
import { C2, C2_FONT } from "../components/Table/C2UserTable";

export const BankDetails = (props) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const navigate = useNavigate();
  const settings = useSelector((state) => state.settingsdata.settings);
  const { state } = useLocation();

  const maskOrShow = (val) => {
    if (!val) return t("no_data_available");
    return settings.AllowCriticalEditsAdmin ? val : t("hidden_demo");
  };

  return (
    <Card
      sx={{
        borderRadius: "20px",
        bgcolor: C2.white,
        mb: 2.5,
        overflow: "hidden",
        boxShadow: "0 8px 28px rgba(26,15,59,0.08)",
        border: `1px solid ${C2.border}`,
      }}
    >
      <Box
        sx={{
          background: `linear-gradient(135deg, ${C2.deep} 0%, ${C2.violet} 100%)`,
          px: { xs: 2, md: 3 },
          pt: 2,
          pb: 2.5,
        }}
      >
        <GoBackButton
          isRTL={isRTL}
          light
          onClick={() => {
            if (props?.data?.usertype === "customer") {
              navigate("/users/0", { state: { pageNo: state?.pageNo } });
            } else if (props?.data?.usertype === "driver") {
              navigate("/users/1", { state: { pageNo: state?.pageNo } });
            } else {
              navigate("/404");
            }
          }}
        />
        <Typography
          sx={{
            fontFamily: C2_FONT,
            fontWeight: 800,
            fontSize: 20,
            color: C2.white,
            mt: 0.5,
          }}
        >
          {t("bankDetails") || "Detalles del banco"}
        </Typography>
        <Typography
          sx={{
            fontFamily: C2_FONT,
            fontSize: 13,
            color: "rgba(251,250,254,0.75)",
            mt: 0.5,
          }}
        >
          Datos bancarios asociados a la cuenta
        </Typography>
      </Box>

      <Box sx={{ p: { xs: 2, md: 3 }, bgcolor: C2.bg }}>
        <Grid container spacing={2} sx={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}>
          <Grid item xs={12} md={4}>
            <Userinfo title="bankName" value={maskOrShow(props.data?.bankName)} />
          </Grid>
          <Grid item xs={12} md={4}>
            <Userinfo title="bankCode" value={maskOrShow(props.data?.bankCode)} />
          </Grid>
          <Grid item xs={12} md={4}>
            <Userinfo title="bankAccount" value={maskOrShow(props.data?.bankAccount)} />
          </Grid>
        </Grid>
      </Box>
    </Card>
  );
};
